import { BuyPlanPageContent } from './BuyPlanPageContent'
import { BuyPlanPageHeaderNav } from '../../TopNav/v2/BuyPlanPageHeaderNav'
import { BuyPlanPageProps } from './BuyPlanPageProps'
import { EmptyNavPageContainer } from '../../layout/EmptyNavPageContainer/EmptyNavPageContainer'
import { FullPageErrorFallback } from '@dtx-company/inter-app/src/components/PageErrorFallback'
import { LoggerErrorBoundary } from '@dtx-company/logger'
import { PlanPurchaseProvider } from '@app/plans/src/purchase/PlanPurchaseProvider/PlanPurchaseProvider'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { getPlanTypeName } from '@app/common/src/utils/getPlanTypeName'
import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import { useBuyPlanPageQuery } from './routing/useBuyPlanPageQuery'
import { useBuyPlanPageRedirects } from './redirects/useBuyPlanPageRedirects'
import { useDefaultPathname } from '@dtx-company/inter-app/src/hooks/useDefaultPathname'
import { useFlowRouter } from '@dtx-company/inter-app/src/hooks/useFlowRouter'

export function InnerBuyPlanPage(props: BuyPlanPageProps): JSX.Element {
  useBuyPlanPageRedirects()

  const flowRouter = useFlowRouter()
  const defaultPathname = useDefaultPathname()

  return (
    <BuyPlanPageContent
      {...props}
      onSuccessfulCheckout={() => {
        flowRouter.replace(defaultPathname)
      }}
    />
  )
}

export function BuyPlanPage(props: BuyPlanPageProps): JSX.Element {
  const { planType } = useBuyPlanPageQuery()
  const { isAuthenticated } = useAuthState()

  return (
    <LoggerErrorBoundary options={{ team: 'monetization' }} fallback={<FullPageErrorFallback />}>
      <EmptyNavPageContainer
        page={Routes.BUY_PLAN_PAGE}
        stickyHeader={true}
        header={
          <BuyPlanPageHeaderNav
            isLoggedIn={isAuthenticated}
            isPositionFixed={false}
            planName={getPlanTypeName(planType)}
          />
        }
      >
        <PlanPurchaseProvider planType={planType}>
          <InnerBuyPlanPage {...props} />
        </PlanPurchaseProvider>
      </EmptyNavPageContainer>
    </LoggerErrorBoundary>
  )
}
